// extracted by mini-css-extract-plugin
export default {"st1":"FilterIcon_st1__8O8ed"};